import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-slate-900" }
const _hoisted_3 = { class: "relative bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl border border-slate-200 overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 rounded-xl bg-white/90 px-4 backdrop-blur-[1px]",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_5 = { class: "lg:hidden mt-4 text-center" }
const _hoisted_6 = { class: "text-xs text-slate-500" }
const _hoisted_7 = { class: "font-semibold text-slate-700" }

import { ref, computed } from "vue";

import SkeletonTablas from "@/share/components/SkeletonTablas.vue";
import ErrorState from "@/share/components/ErrorState.vue";
import PaginationCompontens from "@/share/components/PaginationCompontens.vue";
import ConfirmarAccionModal from "@/share/components/ConfirmarAccionModal.vue";
import { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";
import {
  applyPedidosSortField,
  useCambiarEstadoPedido,
  usePedidosList,
} from "../composables";
import PedidosFiltros from "@/share/components/PedidosFiltros.vue";
import PedidosPagadosTable from "../components/pedidosPagadosComponents/pedidosPagadosTable.vue";
import EmptyStatePedidos from "@/share/components/EmptyStatePedidos.vue";
import PedidoDetallesModal from "@/share/components/PedidoDetallesModal.vue";
import AdminPageShell from "@/share/components/admin/AdminPageShell.vue";
import { useGeneratePedidoPdf } from "../composables/useGeneratePedidoPdf";
// Estado de filtros y paginación

export default /*@__PURE__*/_defineComponent({
  __name: 'PedidosPagadosView',
  setup(__props) {

const params = ref<gpedPedidosPaginacionFilterParams>({
  page: 1,
  limit: 10,
  search: "",
  estadoNombre: "Pagado",
  sortBy: "createdAt",
  sortOrder: "desc",
});
const selectedPedidoId = ref("");
const isModalOpen = ref(false);
const confirmarCambioEstadoOpen = ref(false);
const pedidoIdConfirmacionEstado = ref<string | null>(null);
// Hook de pedidos
const {
  pedidos,
  total,
  totalPages,
  currentPage,
  isPending: isLoadingList,
  isError,
  error,
  refetch,
} = usePedidosList(params);
// Hook de cambio de estado de pedido
const { mutate: cambiarEstado, isPending: isCambiandoEstado } =
  useCambiarEstadoPedido();
const { mutate: generatePdf } = useGeneratePedidoPdf();

// Handlers de búsqueda y filtros
const handleSearch = (search: string) => {
  params.value.search = search;
  params.value.page = 1;
};

const handlePageChange = (page: number) => {
  params.value.page = page;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const handleLimitChange = (limit: number) => {
  params.value.limit = limit;
  params.value.page = 1;
};

const handleSort = (field: string) => {
  applyPedidosSortField(params, field);
};

const pedidoClienteConfirmacion = computed(() => {
  const id = pedidoIdConfirmacionEstado.value;
  if (!id) return "";
  const p = pedidos.value.find((x) => x.id === id);
  if (!p?.cliente) return "";
  return `${p.cliente.nombreCliente} ${p.cliente.apellidoCliente || ""}`.trim();
});

// Acciones de pedidos
const handleViewDetails = (pedidoId: string) => {
  selectedPedidoId.value = pedidoId;
  isModalOpen.value = true;
};
const handleUpdateEstado = (pedidoId: string) => {
  pedidoIdConfirmacionEstado.value = pedidoId;
  confirmarCambioEstadoOpen.value = true;
};

const cerrarConfirmacionCambioEstado = () => {
  if (isCambiandoEstado.value) return;
  confirmarCambioEstadoOpen.value = false;
  pedidoIdConfirmacionEstado.value = null;
};

const ejecutarCambioEstadoACompletado = () => {
  const id = pedidoIdConfirmacionEstado.value;
  if (!id) return;
  cambiarEstado(
    { pedidoId: id, nombreEstado: "Completado" },
    {
      onSettled: () => {
        confirmarCambioEstadoOpen.value = false;
        pedidoIdConfirmacionEstado.value = null;
      },
    }
  );
};
const handleCloseModal = () => {
  isModalOpen.value = false;
};
const handleDescargarPDF = (pedidoId: string) => {
  generatePdf(pedidoId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminPageShell, {
    title: "Pedidos pagados",
    description: "Pedidos en estado Pagado: ventas acreditadas pendientes de marcar como Completadas."
  }, {
    lead: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", {
        class: "rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900",
        role: "status"
      }, [
        _createElementVNode("p", { class: "font-medium" }, "Ventas y seguimiento"),
        _createElementVNode("p", { class: "mt-1 text-emerald-800" }, [
          _createTextVNode(" Aquí solo aparecen pedidos en estado "),
          _createElementVNode("span", { class: "font-semibold" }, "Pagado"),
          _createTextVNode(". Cuando el envío o entrega esté resuelta, márcalos como "),
          _createElementVNode("span", { class: "font-semibold" }, "Completado"),
          _createTextVNode(" con el botón verde de la fila para moverlos al historial. ")
        ])
      ], -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(PedidoDetallesModal, {
        "pedido-id": selectedPedidoId.value,
        "is-open": isModalOpen.value,
        onClose: handleCloseModal
      }, null, 8, ["pedido-id", "is-open"]),
      _createVNode(ConfirmarAccionModal, {
        show: confirmarCambioEstadoOpen.value,
        title: "Confirmar paso a Completado",
        loading: _unref(isCambiandoEstado),
        "confirm-label": "Sí, marcar como Completado",
        "cancel-label": "No, cancelar",
        variant: "danger",
        onCancel: cerrarConfirmacionCambioEstado,
        onConfirm: ejecutarCambioEstadoACompletado
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" Vas a marcar el pedido como ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("strong", { class: "text-slate-900" }, "Completado", -1)),
            _cache[5] || (_cache[5] = _createTextVNode(". ", -1)),
            (pedidoClienteConfirmacion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[1] || (_cache[1] = _createTextVNode(" Cliente: ", -1)),
                  _createElementVNode("strong", _hoisted_2, _toDisplayString(pedidoClienteConfirmacion.value), 1),
                  _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-3 text-slate-700" }, [
            _createTextVNode(" El pedido deja de figurar como pendiente de despacho en el flujo de «Pagado» y esta acción "),
            _createElementVNode("strong", { class: "text-red-700" }, "no se puede deshacer"),
            _createTextVNode(" desde el panel. ")
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-2 text-sm text-slate-500" }, " Comprueba que el envío o la entrega esté resuelta antes de confirmar. ", -1))
        ]),
        _: 1
      }, 8, ["show", "loading"]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(isCambiandoEstado))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "h-10 w-10 shrink-0 animate-spin text-emerald-700",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                })
              ], -1),
              _createElementVNode("p", { class: "text-center text-sm font-semibold text-slate-800" }, " Actualizando estado del pedido… ", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createVNode(PedidosFiltros, {
          params: params.value,
          total: _unref(total),
          onSearch: handleSearch,
          onLimitChange: handleLimitChange
        }, null, 8, ["params", "total"]),
        (_unref(isLoadingList))
          ? (_openBlock(), _createBlock(SkeletonTablas, { key: 1 }))
          : (_unref(isError))
            ? (_openBlock(), _createBlock(ErrorState, {
                key: 2,
                error: _unref(error),
                onRetry: _unref(refetch)
              }, null, 8, ["error", "onRetry"]))
            : (_unref(pedidos).length === 0)
              ? (_openBlock(), _createBlock(EmptyStatePedidos, { key: 3 }))
              : (_openBlock(), _createBlock(PedidosPagadosTable, {
                  key: 4,
                  pedidos: _unref(pedidos),
                  sortField: params.value.sortBy ?? 'createdAt',
                  sortDirection: params.value.sortOrder ?? 'desc',
                  "accion-en-proceso": _unref(isCambiandoEstado),
                  "accion-pedido-id": pedidoIdConfirmacionEstado.value,
                  onSort: handleSort,
                  onViewDetails: handleViewDetails,
                  onUpdateEstado: handleUpdateEstado,
                  onDescargarPdf: handleDescargarPDF
                }, null, 8, ["pedidos", "sortField", "sortDirection", "accion-en-proceso", "accion-pedido-id"])),
        (!_unref(isLoadingList) && !_unref(isError) && _unref(total) > 0)
          ? (_openBlock(), _createBlock(PaginationCompontens, {
              key: 5,
              "current-page": _unref(currentPage),
              "total-pages": _unref(totalPages),
              total: _unref(total),
              limit: params.value.limit,
              onPageChange: handlePageChange
            }, null, 8, ["current-page", "total-pages", "total", "limit"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _cache[9] || (_cache[9] = _createTextVNode(" Total de pedidos: ", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(total)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})